import ccxt from "ccxt";

const exchange = new ccxt.binance();

export default exchange;